module.exports = __webpack_public_path__ + "img/logos_tiktok-icon.bfba382e.svg";